import { render, staticRenderFns } from "./DeleteMarketPic.vue?vue&type=template&id=4d101f8c"
import script from "./DeleteMarketPic.vue?vue&type=script&lang=js"
export * from "./DeleteMarketPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports